import type * as APITypes from '@viamrobotics/web-client/app/v1/app';

import type { OrganizationMembers } from './index';

/**
 * Finds an org member by email, case-insensitively — the backend treats
 * member emails case-insensitively (User.ContainsEmail in data/user.go).
 */
export const findOrgMemberByEmail = (
  orgMembers: OrganizationMembers | undefined,
  email: string
): APITypes.OrganizationMember | undefined => {
  if (!orgMembers) {
    return undefined;
  }
  const members = orgMembers.current
    ? [orgMembers.current, ...orgMembers.others]
    : orgMembers.others;
  const normalizedEmail = email.toLowerCase();

  return members.find((member) =>
    member.emails.some(
      (memberEmail) => memberEmail.toLowerCase() === normalizedEmail
    )
  );
};
